import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  const quickLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Helpful Info',
    path: '/helpful-info'
  }, {
    name: 'Products',
    path: '/Camp-Designs'
  }, {
    name: 'About',
    path: '/About-Us'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <footer className="bg-wh-pink pt-16 pb-8" data-id="element-124">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-126">
          {/* Brand Column */}
          <div data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/6G36xTJ4eeBqvZ8tYXgCey/logo.webp" alt="Wear Haus Designs" className="h-12 w-auto mb-6" data-id="element-128" />
            <p className="text-white/90 mb-6" data-id="element-129">
              We Logo Your Life. Specializing in screen print, embroidery,
              direct to garment and textile laser etching.
            </p>
            <div className="flex space-x-4" data-id="element-130">
              <a href="https://www.facebook.com/wearhausdesigns" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-wh-pink transition-all" data-id="element-131">
                <Facebook className="w-5 h-5" data-id="element-132" />
              </a>
              <a href="https://www.instagram.com/wear.haus.designs/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-wh-pink transition-all" data-id="element-133">
                <Instagram className="w-5 h-5" data-id="element-134" />
              </a>
              <a href="https://twitter.com/WearHausDesigns" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-wh-pink transition-all" data-id="element-135">
                <Twitter className="w-5 h-5" data-id="element-136" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div data-id="element-137">
            <h3 className="text-lg font-bold text-white mb-6" data-id="element-138">Contact Us</h3>
            <ul className="space-y-4" data-id="element-139">
              <li className="flex items-start" data-id="element-140">
                <MapPin className="w-5 h-5 text-wh-yellow mt-1 mr-3 flex-shrink-0" data-id="element-141" />
                <span className="text-white/90" data-id="element-142">
                  4425 West US 20, Suite 1<br data-id="element-143" />
                  LaGrange, Indiana 46761
                </span>
              </li>
              <li className="flex items-center" data-id="element-144">
                <Phone className="w-5 h-5 text-wh-yellow mr-3 flex-shrink-0" data-id="element-145" />
                <a href="tel:260-463-7373" className="text-white/90 hover:text-white transition-colors" data-id="element-146">
                  260-463-7373
                </a>
              </li>
              <li className="flex items-center" data-id="element-147">
                <Mail className="w-5 h-5 text-wh-yellow mr-3 flex-shrink-0" data-id="element-148" />
                <a href="mailto:wearhaus@wearhaus.net" className="text-white/90 hover:text-white transition-colors" data-id="element-149">
                  wearhaus@wearhaus.net
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-150">
            <h3 className="text-lg font-bold text-white mb-6" data-id="element-151">
              Business Hours
            </h3>
            <ul className="space-y-4" data-id="element-152">
              <li className="flex items-start" data-id="element-153">
                <Clock className="w-5 h-5 text-wh-yellow mt-1 mr-3 flex-shrink-0" data-id="element-154" />
                <div data-id="element-155">
                  <span className="block text-white font-medium" data-id="element-156">
                    Monday – Friday
                  </span>
                  <span className="text-white/90" data-id="element-157">8:00 AM to 4:00 PM EST</span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-158">
                <Clock className="w-5 h-5 text-white/30 mt-1 mr-3 flex-shrink-0" data-id="element-159" />
                <div data-id="element-160">
                  <span className="block text-white font-medium" data-id="element-161">
                    Saturday – Sunday
                  </span>
                  <span className="text-white/90" data-id="element-162">Closed</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-163">
            <h3 className="text-lg font-bold text-white mb-6" data-id="element-164">Quick Links</h3>
            <ul className="space-y-3" data-id="element-165">
              {quickLinks.map(item => <li key={item.path} data-id="element-166">
                  <Link to={item.path} className="text-white/90 hover:text-white transition-colors flex items-center" data-id="element-167">
                    <span className="w-1.5 h-1.5 bg-wh-yellow rounded-full mr-2" data-id="element-168"></span>
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-169">
          <p className="text-white/80 text-sm mb-4 md:mb-0" data-id="element-170">
            © {new Date().getFullYear()} Wear Haus Designs. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-white/80" data-id="element-171">
            <a href="#" className="hover:text-white transition-colors" data-id="element-172">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-173">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}